import { useCorreios } from '@contexts/';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getZendeskUrl, zafClient } from '@services/';

export const useSuccess = () => {
  const navigate = useNavigate();
  const { createdTicket } = useCorreios();

  useEffect(() => {
    if (createdTicket) {
      const timer = setTimeout(() => {
        (async () => {
          const id = createdTicket.ticket.id;

          try {
            await zafClient.invoke('routeTo', 'ticket', id);
          } catch {
            window.open(`${getZendeskUrl()}/agent/tickets/${id}`, '_blank');
          }
        })();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [createdTicket]);

  return { navigate, ticket: createdTicket?.ticket.id };
};
